import React, { memo } from 'react'
import ContentLoader from 'react-content-loader'

const FilterSkeleton=(props)=> {
    return (
        <div className="filter-nav after-render" id="filterHeader" style={{top:0}}>
            <div className="navigation" style={{ backgroundColor: `white`, minHeight: 184 }}>
            <div className="menu-wrapper">
                    <div className="nav-menu">
                    <ContentLoader className="trip-filter-skeleton"
                        height={`100%`}
                        width={'100%'}
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                    >
                        <rect x="2%" y="25%" rx="0" ry="0" width="16%" height="20" /> {/*filter1 */}
                        <rect x="22%" y="25%" rx="0" ry="0" width="16%" height="20" /> {/*filter2 */}
                        <rect x="42%" y="25%" rx="0" ry="0" width="16%" height="20" /> {/*filter3 */}
                        <rect x="62%" y="25%" rx="0" ry="0" width="16%" height="20" /> {/*filter4 */}
                        <rect x="82%" y="25%" rx="0" ry="0" width="16%" height="20" /> {/*filter5 */}
                        <rect x="0.5%" y="75%" rx="0" ry="0" width="98%" height="4" /> {/*line sperator */}
                        <rect x="2%" y="95%" rx="0" ry="0" width="20%" height="16" /> {/*participants */}
                        <circle cx="25%" cy="96.2%"  r="10" />
                        <circle cx="28%" cy="96.2%"  r="10" />

                        <rect x="32%" y="95%" rx="0" ry="0" width="20%" height="16" /> {/*participants */}
                     
                    </ContentLoader>
                    </div>
                </div>
            </div>
            </div>
    )
}


export default memo(FilterSkeleton)

